"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HorizontalStack = void 0;
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _HorizontalStackComponent = require("./components/HorizontalStackComponent.js");
var _jsxRuntime = require("react/jsx-runtime");
const _excluded = ["children", "className", "spacing", "width", "height", "minWidth", "maxWidth", "bg", "borderRadius", "justifyContent", "alignItems"];
const HorizontalStack = props => {
  const {
      children,
      className,
      spacing = '0px',
      width = '100%',
      height = '100%',
      minWidth = "0%",
      maxWidth = "100%",
      bg = 'none',
      borderRadius = '0px',
      justifyContent = 'flex-start',
      alignItems = 'center'
    } = props,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  const horizontalStackStyle = [`horizontal-stack`, className].join(' ');
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_HorizontalStackComponent.HorizintalStackComponent, Object.assign({
    spacing: spacing,
    width: width,
    height: height,
    bg: bg,
    borderRadius: borderRadius,
    justifyContent: justifyContent,
    className: horizontalStackStyle,
    alignItems: alignItems,
    minWidth: minWidth,
    maxWidth: maxWidth
  }, rest, {
    children: children
  }));
};
exports.HorizontalStack = HorizontalStack;
var _default = exports.default = HorizontalStack;